<template>
  <div class="footerbg">
    <div class="footer">
      <div class="footer-top">
        <div class="footer-warp-1">
          <span>关注我们</span>
          <a href=""> </a>
          <div class="qrcode"><img src="../assets/img/home/Image.png" alt="" /></div>
          <a href=""> </a>
          <div class="email">postmaster@feichan.tech</div>
        </div>
        <div class="footer-warp-3">
          <img src="../assets/img/home/zcy_logo.png" alt="" />
        </div>
        <div class="footer-warp-4">
          <p>斐宸数字科技(上海)有限公司</p>
          <p>联系地址：上海市嘉定区徐潘路1918号2幢3楼C区</p>
          <p>联系电话：400-6016488</p>
        </div>
      </div>
      <div class="footer-bottom">
        <router-link to="/contact">售前咨询</router-link>
        <router-link to="/contact">售后服务</router-link>
        <router-link to="/about">关于我们</router-link>
        <router-link to="/case">应用案例</router-link>
        <router-link to="/legal">法律声明</router-link>
        <router-link to="/news">新闻动态</router-link>
        <router-link to="/contact">联系我们</router-link>
      </div>
      <div class="copyright"><p style="cursor: pointer" @click="toHref">沪ICP备2022004704号-1 @2025 斐宸数字科技(上海)有限公司 版权所有</p></div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Footer',
  methods: {
    toHref() {
      window.location.href = 'https://beian.miit.gov.cn/#/Integrated/index';
    },
  },
};
</script>
<style scoped>
.footerbg {
  width: 100%;
  height: 444px;
  padding: 100px 0 80px;
  background-color: #1f242f;
}
.footer {
  width: 1200px;
  margin: 0 auto;
  height: 100%;
}
.footer-top {
  width: 100%;
  height: 154px;
  border-bottom: 1px solid #666;
  position: relative;
}
.footer-warp-1 {
  position: relative;
  width: 295px;
  height: 124px;
  line-height: 124px;
}
.footer-warp-1 span {
  font-size: 18px;
  font-weight: 400;
  color: #ffffff;
}
.footer-warp-1 a {
  display: inline-block;
  width: 40px;
  height: 40px;
  margin-left: 30px;
  vertical-align: middle;
}
.footer-warp-1 a:nth-child(2) {
  background: url(../assets/img/home/about_wx.png) no-repeat;
  background-size: contain;
}
.footer-warp-1 a:nth-child(4) {
  background: url(../assets/img/home/about_e-mail.png) no-repeat;
  background-size: contain;
}
.qrcode {
  position: absolute;
  top: -150px;
  left: 30px;
  display: none;
    width: 180px;
  height: 180px;
}
.qrcode img {
  width:100%
}
.email {
  position: absolute;
  left: 20px;
  top: -40px;
  padding-left: 32px;
  width: 357px;
  height: 68px;
  line-height: 68px;
  font-size: 24px;
  color: #333;
  font-weight: bold;
  white-space: nowrap;
  background-color: #fff;
  display: none;
}
.footer-warp-1 a:nth-child(2):hover + .qrcode,
.footer-warp-1 a:nth-child(4):hover + .email {
  display: block;
}
.footer-warp-3 {
  width: 124px;
  height: 124px;
  position: absolute;
  top: 0;
  right: 460px;
  background-color: #fff;
}
.footer-warp-3 img {
   width:100%;
}
.footer-warp-4 {
  position: absolute;
  top: 0;
  right: 0;
}
.footer-warp-4 p {
  margin-bottom: 27px;
  font-weight: 400;
  font-size: 18px;
  color: #fff;
}
.footer-bottom {
  width: 100%;
  height: 24px;
  line-height: 24px;
}
.footer-bottom a {
  display: inline-block;
  font-size: 18px;
  color: #fff;
  margin: 50px 50px 0 0;
}
.copyright {
  margin-top: 80px;
  height: 20px;
  font-size: 18px;
  color: #fff;
}
</style>
